import React, { Component } from 'react';
import { Form, Modal, Select } from 'antd';
import baseData from '@util/base';
import UploadFile from '@comm/upload/UploadFile';

const FormItem = Form.Item;
const { Option } = Select;
class Manage extends Component {
  handleOk = () => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.handleOk({
          type: values.type,
          uuid: values.file[0].uuid,
        });
      }
    });
  };

  render() {
    const {
      form: { getFieldDecorator },
      visible,
      handleCancel,
      fileData = {},
    } = this.props;
    return (
      <Modal
        title="上传附件"
        visible={visible}
        onOk={this.handleOk}
        onCancel={() => handleCancel(false)}
        destroyOnClose
      >
        <Form>
          <FormItem label="附件类型">
            {getFieldDecorator('type', {
              initialValue: fileData.type >= 0 ? `${fileData.type}` : fileData.type,
              rules: [{ required: true, message: '请填写迁出理由' }],
            })(
              <Select>
                {baseData.attachmentType.map(item => (
                  <Option key={item.key}>{item.name}</Option>
                ))}
              </Select>,
            )}
          </FormItem>
          <FormItem label="附件">
            {getFieldDecorator('file', {
              initialValue: fileData.files,
              rules: [{ required: true, message: '请选择附件' }],
            })(<UploadFile type="ghost" limit={1} isPreview />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Manage);



// WEBPACK FOOTER //
// ./src/components/incubator/custom/base/ModalFile.js